// extracted by mini-css-extract-plugin
export default {"status":"TaskForm_status__WoHj4","courierInput":"TaskForm_courierInput__ZTYGB"};